import ui from "./ui.js";


export default function options(state, modelsLibrary, scene){
    const {materialRadios} = ui()
    let firstLoadForMaterial = true
    const priceValue = document.querySelector('.price-value')

    const defaultPrice = 200

    const urlParams = new URLSearchParams(window.location.search);

    const materialParam = urlParams.get('material');


    materialRadios.forEach((item)=>{
        if (materialParam === item.value && firstLoadForMaterial) {
            item.checked = true
            changeMaterial(materialParam)
            firstLoadForMaterial = false
        }

        item.addEventListener('change', event => {
            changeMaterial(event.target.value)
        })

        function changeMaterial(data){
            calculatePrice()

            const url = new URL(window.location)
            url.searchParams.set('material', data)
            window.history.replaceState({}, '', url)

            console.log(modelsLibrary[data])


            let oldRotationY = state.currentModel.rotation.y;
            scene.remove(state.currentModel);


            state.currentModel = modelsLibrary[data]
            state.currentModel.rotation.y = oldRotationY

            state.currentModel.traverse( (child) => {
                if (child.isMesh) {
                    child.castShadow = true;
                    child.receiveShadow = true;

                }
            });

            state.currentModel.position.y = 0.3
            scene.add(state.currentModel);
        }
    })

    function calculatePrice(){
        let price = defaultPrice

        materialRadios.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })

        priceValue.textContent = price

    }
}